<script setup>
import {reactive} from "vue";
import {couponConf} from "@/utils/config";

const stores = reactive(couponConf["hkl-scal"].storeLst)
</script>

<template>
<!--{{ stores.row }}-->
  <el-scrollbar class="scrollbar">
    <el-card shadow="never">
      <el-collapse accordion>
        <el-collapse-item v-for="(parent_i,pid) in stores.row" :key="pid" :title="pid" :name="pid">
          <el-card shadow="never">
            <el-collapse accordion>
              <el-collapse-item v-for="(child_id,child) in parent_i" :key="child" :title="child" :name="child">
                <ul class="store-lst">
                  <li v-for="items in child_id.data" :key="items.number" class="store-items">
                    <div class="store-info">
                      <div class="store-name">门店名称：{{ items.name }}</div>
                    </div>
                    <div class="store-info">
                      <div class="store-name">门店地址：{{ items.address }}</div>
                    </div>
                    <div class="store-info">
                      <div class="store-name">联系电话：{{ items.tel }}</div>
                    </div>
                  </li>
                </ul>
              </el-collapse-item>
            </el-collapse>
          </el-card>
        </el-collapse-item>
      </el-collapse>
    </el-card>
  </el-scrollbar>
</template>

<style scoped lang="less">
.scrollbar{
  height: calc(100vh - 60px);
  //background: #42b983;
  box-sizing: border-box;
  padding: 10px;

  .store-lst{
    list-style: none;
    .store-items{
      padding: 10px;
      &+.store-items{
        border-top: var(--el-border);
      }
    }
  }
}
</style>